export default __webpack_public_path__ + "static/contact-banner-8e12aedb6fe770e2f6bc7b9b91a04da9.jpg";